<mat-accordion class='headers-align' multi='true'>
    <mat-expansion-panel class='expansion-panel'>
        <mat-expansion-panel-header class='expansion-header'>
            <mat-panel-title
                    class='expansion-title'>{{ this.translateService.getTranslatedLabel('label.modify.account.heading') }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]='accountForm' class='account-details-form'>
            <mat-form-field class='mxs-input'>
                <mat-label>{{ this.translateService.getTranslatedLabel('label.username') }}</mat-label>
                <input matInput formControlName='username' readonly/>
            </mat-form-field>

            <mat-form-field class='mxs-input'>
                <mat-label>{{ this.translateService.getTranslatedLabel('label.language') }}</mat-label>
                <mat-select formControlName='userLanguageCode'>
                    @for (language of this.languages(); track language) {
                        <mat-option [value]='language.code'>{{ language.code }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class='mxs-input'>
                <mat-label>{{ this.translateService.getTranslatedLabel('label.company') }}</mat-label>
                <input matInput formControlName='company'/>
                @if (accountForm.get('company')?.touched && accountForm.get('company')?.hasError('maxlength')) {
                    <mat-error class='validation-message'>
                        <span>{{ this.translateService.getTranslatedLabel('label.errors.string.too.long') }}</span>
                    </mat-error>
                }
            </mat-form-field>

            @if (accountForm.get('company')?.value?.trim()) {
                <mat-form-field class='mxs-input'>
                    <mat-label>{{ this.translateService.getTranslatedLabel('label.companyId') }}</mat-label>
                    <input matInput formControlName='companyId'/>
                    @if (accountForm.get('companyId')?.touched && accountForm.get('companyId')?.invalid) {
                        <mat-error class='validation-message'>
                            @if (accountForm.get('companyId')?.hasError('required')) {
                                <span>{{ this.translateService.getTranslatedLabel('label.errors.mandatory') }}</span>
                            }
                            @if (accountForm.get('companyId')?.hasError('pattern')
                            || accountForm.get('companyId')?.hasError('minlength')
                            || accountForm.get('companyId')?.hasError('maxlength')) {
                                <span>{{ this.translateService.getTranslatedLabel('label.errors.companyId') }}</span>
                            }
                        </mat-error>
                    }
                </mat-form-field>
            }

            @if (this.vatPayerEnabled && accountForm.get('company')?.value?.trim()) {
                <mat-form-field class="mxs-input">
                    <mat-label>{{ this.translateService.getTranslatedLabel('label.taxId') }}</mat-label>
                    <input matInput formControlName='taxId' readonly/>
                </mat-form-field>
            }

            <mat-form-field class='mxs-input'>
                <mat-label>{{ this.translateService.getTranslatedLabel('label.product.of.interest') }}</mat-label>
                <input matInput formControlName='productOfInterest' readonly/>
            </mat-form-field>


            <div formArrayName='websites' class='full-row'>
                @for (website of websites().controls; track i; let i = $index) {
                    <div [formGroupName]='i'>
                        <div class='website-container'>
                            <mat-form-field class='mxs-input'>
                                <mat-label>{{ this.translateService.getTranslatedLabel('label.website') }}</mat-label>
                                <input
                                        matInput
                                        type='text'
                                        formControlName='name'
                                        [value]='website.value.name'
                                        (input)='onWebsiteNameChange(i, $event.target.value)'
                                />
                                <mat-error class='validation-message'>
                                    @if (websites().at(i).get('name')?.invalid) {
                                        @if (websites().at(i).get('name')?.hasError('pattern')) {
                                            <span>{{ this.translateService.getTranslatedLabel('label.errors.website') }}</span>
                                        } @else if (websites().at(i).get('name')?.hasError('duplicate')) {
                                            <span>{{ this.translateService.getTranslatedLabel('label.errors.website.unique') }}</span>
                                        }
                                    }
                                </mat-error>
                            </mat-form-field>
                            <div class='website-buttons'>
                                @if (i === 0) {
                                    <mx-button [buttonModel]='addWebsiteBtn'/>
                                } @else {
                                    <mx-button [buttonModel]='deleteWebsiteBtn' (click)='deleteWebsite(i)'/>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div>
                <mx-check-box-field
                        [form]="accountForm"
                        [name]="'messagesEmailNotifier'"
                        [label]="this.translateService.getTranslatedLabel('label.messages.email.notifier')"
                >
                </mx-check-box-field>
                @if (this.showSendPromotions) {
                    <mx-check-box-field
                            [form]="accountForm"
                            [name]="'sendPromotion'"
                            [label]="this.translateService.getTranslatedLabel('label.send.promotions')">
                    </mx-check-box-field>
                }
                @if (this.vatPayerEnabled  && this.accountForm.get('vatPayer')?.value) {
                    <mx-check-box-field
                            [form]="accountForm"
                            [name]="'vatPayer'"
                            [label]="this.translateService.getTranslatedLabel('label.vatPayer')"
                            [readonly]="true"
                    >
                    </mx-check-box-field>
                }
            </div>
        </form>
        <mat-action-row>
            <mx-button [buttonModel]='updateBtn'></mx-button>
        </mat-action-row>
    </mat-expansion-panel>

    <prl-panel heading='label.modify.account.manager'>
        <prl-manager-info></prl-manager-info>
    </prl-panel>

    <prl-panel heading='label.modify.account.contacts.heading' #contacts id='contacts'>
        <prl-contacts></prl-contacts>
    </prl-panel>

    @if (showDocumentation) {
        <prl-panel heading='label.modify.account.documentation' #documents id='documents'>
            <prl-documents></prl-documents>
        </prl-panel>
    }

</mat-accordion>
